import axios from 'axios';
import { useState, useEffect } from 'react';
import { OpenAI, OpenAIApi, Configuration} from "openai";
import { Grid, Card, Container} from "@mui/material";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import MKInput from "components/MKInput";
import MKAlert from "components/MKAlert";
import Loading from "components/Loading";
import "./main.css"

const Sample = () => {
  const openai = new OpenAI({apiKey: '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', dangerouslyAllowBrowser: true});
  const [apiResponse, setApiResponse] = useState("");
  const [loading, setLoading] = useState(false);
  const [showTag, setShowTag] = useState(false);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const [name, setName] = useState("");
  const [tag, setTag] = useState("");

  const callAI = async()=>{
    if(name === ""){
        alert("Please input your name")
    }
    else{
        setLoading(true);
        try {
          const result = await openai.chat.completions.create({
            messages: [{ role: "system", content: "You are a gamer who comes up with the best gamer tags." },
            { role: "user", content: "give me tweleve fun gamer tags for " + name + " in json" }],
              model: "gpt-3.5-turbo-1106",
              response_format:{ "type": "json_object" },
              temperature: 0.1
          }).then((res) => {
            var gamertagsJson = JSON.parse(res.choices[0].message.content)
            var gamertagsArr = [];
            gamertagsJson.gamerTags.forEach(element => {
                gamertagsArr.push(<Grid textAlign={"center"} item lg={3} md={12} sm={12}>
                     <MKButton onClick={HandleSelect} color={"info"} fullWidth>{element}</MKButton>   
                </Grid>)
            })
            setApiResponse(gamertagsArr);
          });
        } catch (e) {
          console.log(e);
        }
        setLoading(false);
    }
    
  }

const HandleInput = (e)=> {
    setName(e.target.value)
  }

  const HandleSelect = (e) => {
    if(e.currentTarget.classList.contains("selected")){
        e.currentTarget.classList.remove("selected")
    }
    else{
        e.currentTarget.classList.add("selected")
        setTag(e.currentTarget.innerText)
        window.scrollTo(0,0);
    }
    
  }

  useEffect(()=>{
    if(tag != ""){
        setShowTag(true)
    }
    
  },[tag])
  return (
    <>
    {loading ? 
    <Loading/>
     : ''}
    <Container>
    <Grid mt={10} spacing={2} container justifyContent="center" xs={12} lg={12}>
    <Grid item lg={12}>
        {showTag ? <MKAlert dismissible fullWidth>You are now {tag}</MKAlert> : ''}
        </Grid>   
    <Grid textAlign={"center"} item lg={12}>
    <MKTypography variant={"h3"} mb={1}>Sample Project</MKTypography>
    </Grid>
    <Grid item lg={12} textAlign={"center"}>
    <MKTypography variant={"h2"} color={"info"} mb={5}>A.I Gamer Tag</MKTypography>
    </Grid>
          <Grid item lg={10} md={9} sm={12}>
            <MKInput size="large" onChange={HandleInput} label="What is your name" fullWidth></MKInput>
          </Grid>
          <Grid item lg={2} md={3} sm={4}>
            <MKButton onClick={callAI} size="large" color="error">Get A.I Gamer Tag</MKButton>
          </Grid>
        </Grid>
    </Container>
    
      {apiResponse && (
        <Container>
<Grid justifyContent={"center"} container spacing={3} mt={5} textAlign={"center"} mb={10}>
    <Grid item lg={12}><MKTypography variant={"h4"} mb={3}>Here are some fun gamer tags</MKTypography></Grid> 
            {apiResponse}
        </Grid>
        </Container>
        
      )}
    </>
  );
};
export default Sample;



